/**
 * Gemeinsames Noble-Slate Dokumenten-Styling für PE Papers
 * (Vorschau / PDF / Druck — analog Abmahnung / Änderungsvertrag).
 */

export const PE_PAPERS_NOBLE_SLATE_CSS = `
  .av-a4-page {
    display: block !important;
    width: 100% !important;
    max-width: 210mm !important;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    color: #0f172a !important;
    font-size: 12px !important;
    line-height: 1.48 !important;
    padding: 11mm 13mm !important;
    background: #ffffff !important;
  }
  .av-a4-page * { box-sizing: border-box !important; }
  .av-a4-page .pdf-letterhead {
    width: 100% !important;
    text-align: center !important;
    border-bottom: 2px solid #1e293b !important;
    margin: 0 0 12px !important;
    padding: 0 0 10px !important;
  }
  .av-a4-page .pdf-letterhead h1 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 20px !important;
    font-weight: 900 !important;
    letter-spacing: 0.12em !important;
    text-transform: uppercase !important;
    color: #0f172a !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 0 3px !important;
    text-align: center !important;
  }
  .av-a4-page .pdf-letterhead h2 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    letter-spacing: 0.16em !important;
    text-transform: uppercase !important;
    color: #b48a56 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    text-align: center !important;
  }
  .av-meta-grid {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin: 0 0 12px !important;
    border: 1px solid #cbd5e1 !important;
    background: #f8fafc !important;
  }
  .av-meta-col {
    display: table-cell !important;
    width: 50% !important;
    vertical-align: top !important;
    padding: 10px 12px !important;
    font-size: 12.5px !important;
    line-height: 1.45 !important;
    color: #334155 !important;
    text-align: left !important;
  }
  .av-meta-col + .av-meta-col { border-left: 1px solid #e2e8f0 !important; }
  .av-meta-label {
    display: block !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.12em !important;
    color: #64748b !important;
    margin: 0 0 4px !important;
  }
  .av-meta-col strong { color: #0f172a !important; font-weight: 700 !important; }
  .av-meta-col p {
    width: 100% !important;
    margin: 0 !important;
    text-align: left !important;
    font-size: 12.5px !important;
    line-height: 1.45 !important;
    color: #334155 !important;
  }
  .av-meta-col .av-meta-date {
    display: block !important;
    margin-top: 4px !important;
    color: #64748b !important;
    font-size: 12px !important;
  }
  .av-doc-section {
    display: block !important;
    width: 100% !important;
    margin: 0 0 12px !important;
  }
  .av-a4-page h3,
  .av-doc-section > h3 {
    display: block !important;
    width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 12.5px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    text-align: left !important;
    background: #1e293b !important;
    color: #f8fafc !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 6px 10px !important;
    margin: 0 0 8px !important;
  }
  .av-a4-page p,
  .av-doc-p,
  .av-doc-section p {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    font-size: 12px !important;
    line-height: 1.48 !important;
    color: #1e293b !important;
    text-align: justify !important;
    margin: 0 0 8px !important;
  }
  .pepapers-print-break {
    page-break-before: always !important;
    break-before: page !important;
  }
  .ab-sig-table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
    margin-top: 28px !important;
    border: none !important;
  }
  .ab-sig-table td {
    width: 50% !important;
    vertical-align: top !important;
    border: none !important;
    background: transparent !important;
    padding: 0 8px 0 0 !important;
  }
  .ab-sig-table td + td { padding: 0 0 0 8px !important; }
  .ab-sig-table p {
    text-align: left !important;
    margin: 0 0 6px !important;
    width: auto !important;
    max-width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    color: #334155 !important;
  }
  .ab-sig-line-soft {
    display: block !important;
    width: 200px !important;
    max-width: 100% !important;
    border: none !important;
    border-bottom: 2px solid #1e293b !important;
    margin-top: 36px !important;
    margin-bottom: 6px !important;
    height: 0 !important;
    padding: 0 !important;
    background: transparent !important;
  }
  @media print {
    @page { size: A4; margin: 0; }
    body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    .av-a4-page {
      box-shadow: none !important;
      margin: 0 !important;
      max-width: none !important;
      width: 100% !important;
      min-height: 0 !important;
    }
  }
`;

export const PE_PAPERS_NOBLE_PRINT_CSS = `
${PE_PAPERS_NOBLE_SLATE_CSS}
html, body {
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
}
`;

/**
 * Brief-Layout (Kündigung / Freistellung):
 * Lesbare Noble-Slate-Typo — ohne min-height:297mm im Capture-CSS
 * (das erzeugte sonst oft eine 2. leere PDF-Seite).
 * A4-Vorschau-Höhe nur über Tailwind am Preview-Node.
 */
export const PE_PAPERS_NOBLE_SLATE_LETTER_CSS = `
${PE_PAPERS_NOBLE_SLATE_CSS}
  .av-a4-page.av-letter-page {
    min-height: 0 !important;
    height: auto !important;
    padding: 12mm 14mm 12mm 14mm !important;
    font-size: 12px !important;
    line-height: 1.48 !important;
  }
  .av-letter-page .pdf-letterhead {
    margin: 0 0 12px !important;
    padding: 0 0 10px !important;
  }
  .av-letter-page .pdf-letterhead h1 {
    font-size: 18px !important;
    letter-spacing: 0.1em !important;
    margin: 0 0 3px !important;
  }
  .av-letter-page .av-meta-grid {
    margin: 0 0 12px !important;
  }
  .av-letter-page .av-meta-col {
    padding: 10px 12px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
  .av-letter-page .av-meta-col p {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
  .av-letter-page .av-doc-section {
    margin: 0 0 10px !important;
  }
  .av-letter-page h3,
  .av-letter-page .av-doc-section > h3 {
    font-size: 12.5px !important;
    padding: 6px 10px !important;
    margin: 0 0 8px !important;
  }
  .av-letter-page p,
  .av-letter-page .av-doc-p,
  .av-letter-page .av-doc-section p {
    font-size: 12px !important;
    line-height: 1.48 !important;
    margin: 0 0 8px !important;
  }
  .av-letter-closing {
    margin-top: 18px !important;
    padding-top: 4px !important;
    width: 100% !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  .av-letter-page .ab-sig-table {
    margin-top: 14px !important;
  }
  .av-letter-page .ab-sig-line-soft {
    width: 200px !important;
    margin-top: 28px !important;
    margin-bottom: 6px !important;
  }
  .av-letter-page .pepapers-print-break {
    page-break-before: auto !important;
    break-before: auto !important;
  }
`;

/** @deprecated Alias — Brief-Layout statt Ultra-Kompakt */
export const PE_PAPERS_NOBLE_SLATE_COMPACT_CSS = PE_PAPERS_NOBLE_SLATE_LETTER_CSS;

export const PE_PAPERS_NOBLE_PRINT_LETTER_CSS = `
${PE_PAPERS_NOBLE_SLATE_LETTER_CSS}
html, body {
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
}
`;

/** @deprecated Alias */
export const PE_PAPERS_NOBLE_PRINT_COMPACT_CSS = PE_PAPERS_NOBLE_PRINT_LETTER_CSS;

export const PE_PAPERS_A4_PREVIEW_CLASS =
    'av-a4-page bg-white text-slate-900 my-4 mx-auto w-full max-w-[210mm] h-auto min-h-0 shadow-xl rounded-sm text-left block overflow-visible print:my-0 print:shadow-none';

export const PE_PAPERS_A4_LETTER_PREVIEW_CLASS =
    'av-a4-page av-letter-page bg-white text-slate-900 my-4 mx-auto w-full max-w-[210mm] min-h-[297mm] h-auto flex flex-col shadow-xl rounded-sm text-left overflow-visible print:my-0 print:shadow-none print:min-h-0';

export const PE_PAPERS_DOC_P_CLASS = 'av-doc-p text-justify text-slate-800 leading-relaxed';
